import store from '@/store/index.js'
let dic = store.state.dic;

import porvince from "@/assets/json/province.js";
export default function Configs(that) {

    const formItems = [
        // {
        //     label: "姓名",
        //     span: 24,
        //     model: "studentName",
        //     disabled: true,
        // },
        // {
        //     label: "录取专业",
        //     span: 24,
        //     model: "originalMajorName",
        //     disabled: true,
        // },
        // {
        //     label: "学生类别",
        //     span: 24,
        //     model: "type",
        //     disabled: true,
        //     type: 'select',
        //     options: [
        //         { label: '普通学生', value: "0" },
        //         { label: '体育生', value: "1" },
        //         { label: '单招', value: "2" },
        //         { label: '艺术生', value: "3" },
        //     ],
        // },
        // {
        //     label: "学生省份",
        //     span: 24,
        //     model: "sourceProvince",
        //     disabled: true,
        //     // type: 'select',
        //     // options: porvince,
        // },
        // {
        //     label: "考生号",
        //     span: 24,
        //     model: "examNumber",
        //     disabled: true,
        // },
        // {
        //     label: "高考分数",
        //     span: 24,
        //     model: "examScore",
        //     disabled: true,
        // },
    ]
    const formRules = {
        'applyMajorId': [{
            required: true,
            message: "请选择拟调配专业",
            trigger: "blur"
        }],
    }

    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            minWidth: 140,
            show: true
        },
        {
            label: "原专业",
            prop: "originalMajorName",
            align: "center",
            show: true,
        },
        {
            label: "申请专业",
            prop: "applyMajorName",
            align: "center",
            show: true,
        },
        {
            label: "审批状态",
            prop: "processStatusName",
            align: "center",
            show: true,
        },
        {
            label: "拒绝/取消原因",
            prop: "fullMsg",
            align: "center",
            show: true,
        },
        {
            label: "申请时间",
            prop: "createTime",
            align: "center",
            show: true,
        },
    ]

    return {
        formItems,
        formRules,
        tableColumns
    }
}
